import styled from 'styled-components';

export const MappingRulesButton = styled.div`
  width: 127px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #e9f3fd;
  border: 1px solid #0046ff;
  border-radius: 4px;
  color: #0046ff;
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.01em;
  line-height: 20px;
  height: 34px;
  cursor: ${({ disabled }: { disabled: any }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }: { disabled: any }) => (disabled ? '0.4' : '1')};
`;
